export default __webpack_public_path__ + "static/media/Icon12.3fa9c6dd.svg";